import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import QuestionList from "../QuestionList/QuestionList";
import { BASE_URL } from '../../utils/api';
// const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const SearchResults = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get("query");
  const [questions, setQuestions] = useState([]);
  const [filteredQuestions, setFilteredQuestions] = useState([]);

  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const res = await fetch(`${BASE_URL}/questions/`);
        if (res.ok) {
          const data = await res.json();
          setQuestions(data); // ✅ Store all questions
        } else {
          console.error("Failed to fetch questions");
        }
      } catch (err) {
        console.error("Error fetching questions:", err);
      }
    };

    fetchQuestions();
  }, []);

  useEffect(() => {
    if (!query || questions.length === 0) {
      console.log("No query or questions available.");
      setFilteredQuestions([]);
      return;
    }

    const lowerSearch = query.toLowerCase();
    const results = questions.filter((q) =>
      q.title?.toLowerCase().includes(lowerSearch) ||
      (Array.isArray(q.tags) && q.tags.some(tag => tag.toLowerCase().includes(lowerSearch)))
    );

    console.log("Search query:", query);
    console.log("Filtered results:", results);

    setFilteredQuestions(results);
  }, [query, questions]);

  return (
    <div>
      <h2>Search Results for: "{query}"</h2>
      {filteredQuestions.length > 0 ? (
        <QuestionList questions={filteredQuestions} />
      ) : (
        <p>No results found. Try a different search term.</p>
      )}
    </div>
  );
};

export default SearchResults;